import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

export const Body = styled.div`
  font-family: ${tokens.typography.fontFamily.primary};

  form {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  label {
    display: inline-block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: ${color.text.label};

    ::after {
      content: '*';
      color: ${color.error.main};
      padding-left: 2px;
    }
  }

  .advanced-config {
    margin-top: 8px;
  }

  .container-keyword,
  .container-password {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .input-custom-keyword {
    width: 150px;
  }

  .container-url {
    display: flex;
    align-items: center;
    gap: 8px;

    span {
      font-size: 14px;
      color: ${color.text.secondary};
    }

    input {
      width: 170px;
    }
  }
`
